import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row g-0"
}
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "card-contact-person__image" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "card-contact-person__content" }
const _hoisted_6 = { class: "card-contact-person__title" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "card-contact-person__body" }
const _hoisted_10 = ["href"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-fw fa-phone-alt" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = ["href"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-fw fa-envelope" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LazyImage = _resolveComponent("LazyImage")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card-contact-person", _ctx.classes]),
    ref: "root"
  }, [
    (_ctx.contactPerson !== null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (_ctx.contactPerson.image)
                ? (_openBlock(), _createBlock(_component_LazyImage, {
                    key: 0,
                    src: _ctx.getImageSrc(_ctx.contactPerson.image),
                    formats: _ctx.getImageFormats(_ctx.contactPerson.image),
                    "high-res": false
                  }, null, 8, ["src", "formats"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", {
                  innerHTML: _ctx.contactPerson.title
                }, null, 8, _hoisted_7),
                _createElementVNode("div", {
                  innerHTML: _ctx.contactPerson.designation
                }, null, 8, _hoisted_8)
              ]),
              _createElementVNode("div", _hoisted_9, [
                (_ctx.contactPerson.phone)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_ctx.contactPerson.phone)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: _ctx.getPhoneRef(_ctx.contactPerson.phone)
                          }, [
                            _hoisted_11,
                            _createTextVNode(" " + _toDisplayString(_ctx.contactPerson.phone), 1)
                          ], 8, _hoisted_10))
                        : _createCommentVNode("", true),
                      _hoisted_12
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.contactPerson.email)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (_ctx.contactPerson.email)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: `mailto:${_ctx.contactPerson.email}`
                          }, [
                            _hoisted_14,
                            _createTextVNode(" " + _toDisplayString(_ctx.contactPerson.email), 1)
                          ], 8, _hoisted_13))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}